export default __webpack_public_path__ + "static/media/sideprofile-img.c9f65751.png";